import { useState } from 'react';
import fuzzy from 'fuzzy';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import SelectionPanel from 'automation-ui-canvas/create/SelectionPanel';
import useWorkflowTypePQLs from 'automation-ui-enrollment/components/workflowType/hooks/useWorkflowTypePQLs';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ObjectTypeSelectionPanel({
  onClose,
  setObjectTypeId,
  stagedTriggerOption,
  onSelectTriggerOption,
  heading,
  subHeading,
  noneOption
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const {
    options: allObjectTypeOptions,
    shouldSelectObjectType,
    CustomModal,
    onCloseCustomModal
  } = useWorkflowTypePQLs({
    objectTypeFilter: objectTypeId => {
      if (objectTypeId === UNKNOWN_ID) {
        return noneOption !== undefined;
      }
      if (stagedTriggerOption.type === 'EVENT') {
        const {
          blockedObjectTypeIds = []
        } = stagedTriggerOption;
        return !blockedObjectTypeIds.includes(objectTypeId);
      }
      return true;
    }
  });
  const objectTypeSearchResults = fuzzy.filter(searchTerm, allObjectTypeOptions, {
    extract: ({
      text
    }) => text
  }).sort(({
    score: scoreA
  }, {
    score: scoreB
  }) => scoreB - scoreA).map(({
    original
  }) => original);
  if (noneOption !== undefined) {
    objectTypeSearchResults.unshift(noneOption);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [CustomModal && /*#__PURE__*/_jsx(CustomModal, {
      onClose: onCloseCustomModal
    }), /*#__PURE__*/_jsx(SelectionPanel, {
      heading: heading !== null && heading !== void 0 ? heading : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createWorkflow.objectTypeSelectionPanel.title"
      }),
      subHeading: subHeading,
      options: objectTypeSearchResults,
      searchTerm: searchTerm,
      onSearchTermChange: setSearchTerm,
      onClose: onClose,
      onSelectOption: option => {
        if (shouldSelectObjectType(option.value)) {
          onSelectTriggerOption(stagedTriggerOption);
          setObjectTypeId(option.value);
        }
      }
    })]
  });
}